import React from 'react';
import classes from './values.module.css';
import Title from "../../containers/title/title";

const Values = ({values}) => {
    return (
        <div className={classes.Container}>
            <Title title={values?.title} />
            <div className={classes.List}>
                {values?.core_values?.map((value, i) => <div key={i} className={classes.Value}>
                    <h4>{value.name}</h4>
                    <p>{value.description}</p>
                </div>)}
            </div>
        </div>
    )
}
export default Values;